<script>
  import Section from './Section.svelte';
  import {ACCENT_COLOR} from '../packager/brand';
  const color = ACCENT_COLOR;
</script>

<style>
  /*
  .badge {
    background-color: #8CA9FF;
    border-bottom: 2px solid #6278C5;
    color: white;
    padding: 2px 5px;
    border-radius: 4px;
  }
  ul {
    margin: 0;
  }
  */
</style>

<!--
<Section accent={color}>
  <div lang="en">
    <p><span class="badge">New!</span></p>
  </div>
</Section>
-->
